import { AdditionalFilter } from '../rulebook/additional-filter';

export class ImpactAssessmentFilter extends AdditionalFilter {
    filterType: string;
    fromDate: string | null;
    toDate: string | null;
    legalEntity: string[];
    assessmentTeam: string[];
    reviewTeam: string[];
    implementationTeam: string[];
    assessmentStatus: string[];
    reviewStatus: string[];
    implementationStatus: string[];
    jurisdiction: string[];
    assessor: string[];
    RegulationId?: number[]=[];
    PageSize: number;
    Page: number;

    constructor() {
        super();
        this.filterType = '';
        this.fromDate = null;
        this.toDate = null;
        this.legalEntity = [];
        this.assessmentTeam = [];
        this.reviewTeam = [];
        this.implementationTeam = [];
        this.assessmentStatus = [];
        this.reviewStatus = [];
        this.implementationStatus = [];
        this.jurisdiction = [];
        this.assessor = [];
        this.RegulationId=[];
        this.PageSize = 30;
        this.Page = 1;
    }
}
